export default __webpack_public_path__ + "794b8de6dba16f217e6b94ce59fcbd8c.png";